import React from 'react';
import '../../css/components/Profile/ProfileLoading.css';

const ProfileLoading = ({ isMobile }) => {
  return (
    <div className="profile-loading">
      <div className="profile-loading-content">
        <div className="profile-loading-spinner"></div>
        <div className="profile-loading-text">Loading Profile...</div>
      </div>
    </div>
  );
};

export default ProfileLoading; 